import { createRoot } from 'react-dom/client';
import routerRoot from './scripts/router';
import './index.scss';

createRoot(document.getElementById('root')!).render(routerRoot);
